import { UploadOutlined } from "@ant-design/icons";
import {
  action,
  handleBeforeUpload,
  handleFileChanged,
  handleUpload,
} from "@src/helpers/fileUpload";
import { Button, Form, FormInstance, Upload } from "antd";
import { useEffect } from "react";

interface props {
  form: FormInstance;
}

const UploadOfflineFile = (props: props) => {
  const { form } = props;
  const offlineFile = Form.useWatch("offlineFile", form);
  

  useEffect(() => {
    if (offlineFile) {
      form.setFieldValue(
        "offlineFile",
        offlineFile?.fileList || offlineFile || []
      );
    }
  }, [offlineFile]);

  return (
    <Form.Item
      name="offlineFile"
      label="Offline File"
      rules={[{ required: true, message: "Offline file is required." }]}
    >
      <Upload
        name="fileList"
        action={action}
        customRequest={(e) => handleUpload(e)}
        beforeUpload={(args) => handleBeforeUpload(args, "offline_file",["text/plain"])}
        onChange={(e) => handleFileChanged(e)}
        fileList={offlineFile?.fileList || offlineFile || []}
      >
        <Button icon={<UploadOutlined />}>Upload</Button>
      </Upload>
    </Form.Item>
  );
};

export default UploadOfflineFile;
